export default __webpack_public_path__ + "static/media/A4L1.d6404a85.jpg";